/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, DestroyRef, HostListener, OnInit, TemplateRef, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { TranslationService } from "./shared/service/translation.service";
import { CommonModalService } from 'src/app/modules/events/services/common-modal.service';
import { LanguageService } from "./shared/service/language.service";
import { AuthAmplifyService } from "./shared/service/auth-amplify.service";
import { NavigationEnd, Router, RouterOutlet } from "@angular/router";
import { NgbDatepickerI18n, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { Injectable } from "@angular/core";
import { StoreManagerService } from "./shared/store-manager/services/store-manager.service";
import { CrowdinOtaService } from "./shared/service/crowdin-ota/crowdin-ota.service";
import { HeaderComponent } from "./components/header/header.component";
import { FooterComponent } from "./components/footer/footer.component";
import { RefreshSessionComponent } from "./components/refresh-session/refresh-session.component";
import { LoadingSpinnerComponent } from "./components/loading-spinner/loading-spinner.component";
import { LanguageSelectionComponent } from "./shared/components/language-selection/language-selection.component";

const WEEKDAYS = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];
const MONTHS_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

@Injectable({ providedIn: 'root' })
export class AppDatepickerI18n extends NgbDatepickerI18n {
  getWeekdayLabel(weekday: number): string { return WEEKDAYS[weekday - 1]; }
  getMonthShortName(month: number): string { return MONTHS_SHORT[month - 1]; }
  getMonthFullName(month: number): string { return MONTHS_SHORT[month - 1]; }
  getDayAriaLabel(date: NgbDateStruct): string { return `${date.day}-${date.month}-${date.year}`; }
}

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  standalone: true,
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    RefreshSessionComponent,
    LoadingSpinnerComponent,
    LanguageSelectionComponent,
  ],
})
export class AppComponent implements OnInit {
  private readonly translationService = inject(TranslationService);
  private readonly commonModalService = inject(CommonModalService);
  private readonly languageService = inject(LanguageService);
  private readonly authAmplifyService = inject(AuthAmplifyService);
  private readonly route = inject(Router);
  private readonly _crowdinOtaService = inject(CrowdinOtaService);
  private readonly _storeManagerService = inject(StoreManagerService);

  title = "admin-console";
  translatedArray: any[] = [];
  language: string = 'en-GB';
  openModalFlag: boolean = false;
  private readonly destroyRef = inject(DestroyRef);
  public enableLeftPanelView: boolean = false;
  public refSessionComAvailable: boolean = false;
  routeToView: boolean = false;
  public showLanguageSelectionModal: boolean = false;
  public languageSelection!: TemplateRef<any> | null;
  public allSupportedLangCodes: any[] = [];


  isLoggedIn: boolean = true
  isProfileAvailable: any = localStorage.getItem('profile')
  @HostListener("window:popstate")
  async onBrowserBackBtnClose() {
    const dbs = await window.indexedDB.databases();
    dbs.forEach((db: any) => {
      window.indexedDB.deleteDatabase(db.name);
    });
  }

  constructor() {
    this.initializeAllModules();
  }

  async ngOnInit() {
    this.languageService.showLanguageSelectionModal$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: boolean) => {
      this.showLanguageSelectionModal = data;
    });

    await this._crowdinOtaService.initializeLanguage();

    localStorage.setItem('isDealer', 'true');

    this.route.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((events) => {

      if (events instanceof NavigationEnd) {
        if (localStorage.getItem('aliasGroupName') && !localStorage.getItem('profileName')) {
          this.route.navigate(['profile'])
        }
      }
    })
    this.commonModalService.participantQrModalStream$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: boolean) => {
      if (data !== null || data !== undefined) {
        this.openModalFlag = data;
      }
    });
  }

  public initializeAllModules(): void {
    const fullURL = window.location.href.split('/');
    this.allSupportedLangCodes = this.translationService.getSupportedLanguageByCode();
    if (this.allSupportedLangCodes.includes(fullURL[3])) {
      this._storeManagerService.setUserLanguageToStore(fullURL[3]);
    }
    const selectedLang = this.languageService.getLanguage();
    if (selectedLang) {
      this.language = selectedLang;
    } else {
      this.language = this.allSupportedLangCodes.find(lang => lang.includes('en')) ?? 'en-GB';
      this._storeManagerService.setUserLanguageToStore(fullURL[3]);
    }
    this.translationService.getBpConfigurations();
    const featureFlags = this.translationService.featureFlags;
    this.enableLeftPanelView = featureFlags?.locations.enableLeftPanelView;
    this.refSessionComAvailable = featureFlags?.profile.isRefSessionComAvailable;
  }


}